export interface Member {
  type: string;
  ref: string;
  firstName?: string;
  lastName?: string;
  organizationName?: string;
  memberId?: number;
  isProspectInfo?: boolean;
}
